import styled from 'styled-components'
import { Grid as GridFlex } from 'react-styled-flexboxgrid'

const Grid = styled(GridFlex)`
    max-width: 100%;
    box-sizing: content-box;
`

export default Grid
